import { myQueriesListData, modifyQuery, createQueriesData, viewQuery } from 'api/queries';
import { asyncThunkWrapper } from 'utils/AsyncThunkWrapper';

const fetchMyQueriesList = asyncThunkWrapper('myQueries/fetch', myQueriesListData);
const fetchEditQueryDetails = asyncThunkWrapper('myQueries/editDetails', modifyQuery);
const fetchCreateQuery = asyncThunkWrapper('myQueries/createQuery', createQueriesData);
const fetchViewQueryDetails = asyncThunkWrapper('myQueries/viewDetails', viewQuery);

export { fetchMyQueriesList, fetchEditQueryDetails, fetchCreateQuery, fetchViewQueryDetails };
